exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar[data-v-68d67528] {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 70px;\r\n    bottom: 0;\r\n    overflow-y: scroll;\n}\n.sidebar[data-v-68d67528]::-webkit-scrollbar {\r\n    width: 0;\n}\n.sidebar-el-menu[data-v-68d67528]:not(.el-menu--collapse) {\r\n    width: 250px;\n}\n.sidebar > ul[data-v-68d67528] {\r\n    height: 100%;\n}\r\n", ""]);

// exports
